import { useMutation } from 'react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { useErrors } from '../../../../hooks/errors/use-errors';
import { useNative } from '../../../../hooks/native/use-native';
import { useHttpClient } from '../../../../utils/clients/rest-client';
import {
  SetOnOffRequest,
  SetOnTimeRequest,
  SetSupplyReturnBehaviourRequest,
  SwitchSetOffData,
  SwitchSetOnData,
  SwitchSetOnTimeData,
  SwitchSupplyReturnBehaviorData,
  SwitchSupplyReturnBehaviorError,
} from '../../types/openapi/openapi-types';

export const useSwitchSetOn = () => {
  const httpClient = useHttpClient();
  const { handleRestErrors, handleLavvaResolve } = useErrors();
  const { fireVibration } = useNative();

  return useMutation<AxiosResponse<SwitchSetOnData>, AxiosError<void>, SetOnOffRequest>(
    ['switch-setOn'],
    async (body) => {
      fireVibration();
      return await httpClient.switch.switchSetOn(body);
    },
    {
      onSuccess: ({ data }, body) => {
        handleLavvaResolve({ status: data.publishStatus, deviceId: body.deviceId });
      },
      onError: (error) => handleRestErrors(error),
    },
  );
};

export const useSwitchSetOff = () => {
  const httpClient = useHttpClient();
  const { handleRestErrors, handleLavvaResolve } = useErrors();
  const { fireVibration } = useNative();

  return useMutation<AxiosResponse<SwitchSetOffData>, AxiosError<void>, SetOnOffRequest>(
    ['switch-setOff'],
    async (body) => {
      fireVibration();
      return await httpClient.switch.switchSetOff(body);
    },
    {
      onSuccess: ({ data }, body) => {
        handleLavvaResolve({ status: data.publishStatus, deviceId: body.deviceId });
      },
      onError: (error) => handleRestErrors(error),
    },
  );
};

export const useSwitchSetOnTime = () => {
  const httpClient = useHttpClient();
  const { handleRestErrors, handleLavvaResolve } = useErrors();
  const { fireVibration } = useNative();

  return useMutation<AxiosResponse<SwitchSetOnTimeData>, AxiosError<void>, SetOnTimeRequest>(
    ['switch-setOnTime'],
    async (body) => {
      fireVibration();
      return await httpClient.switch.switchSetOnTime(body);
    },
    {
      onSuccess: ({ data }, body) => {
        handleLavvaResolve({ status: data.publishStatus, deviceId: body.deviceId });
      },
      onError: (error) => handleRestErrors(error),
    },
  );
};

export const useSwitchSupplyReturnBehaviour = () => {
  const httpClient = useHttpClient();
  const { handleRestErrors } = useErrors();

  return useMutation<
    AxiosResponse<SwitchSupplyReturnBehaviorData>,
    AxiosError<SwitchSupplyReturnBehaviorError>,
    SetSupplyReturnBehaviourRequest
  >(['switch-supplyReturnBehavior'], async (body) => await httpClient.switch.switchSupplyReturnBehavior(body), {
    onError: (error) => handleRestErrors(error),
  });
};
